<template>
  <div class="sd-geometry-editor shadow" v-drag v-show="dialogVisible_">
    <div class="editor-panle__header">  
      <div class="content">编辑图层：<strong>{{ layerInfo_?.alias || '' }}</strong></div>
      <div class="content-row" @mousedown.stop="()=>{}">
        <el-button type="text" v-if="addible_" @click="addDrawTool" >
          <i class="el-icon-edit">{{drawTool_?'取消':'新增'}}</i>
        </el-button>
        <el-button type="text" @click="addModifyTool(!modifyTool_)">
          <i class="el-icon-edit">{{modifyTool_?'取消':'修改'}}</i>
        </el-button>
        <el-checkbox v-model="isRectifyingGeometry_">校正图形</el-checkbox>
      </div>
    </div> 
    <div class="editor-panle__body content-row" @mousedown.stop="()=>{}">
      <el-select v-model="selectField_" placeholder="请选择字段" size="small" @change="addFieldRow" style="width: 100%;">
        <el-option
          v-for="field in filterFields_"
          :key="field"
          :label="field"
          :value="field">
        </el-option>
      </el-select>
      <div class="input-field-values" v-if="displayFields_ && displayFields_.length > 0">
        <div v-for="field in displayFields_" :key="field.name" class="between-flex field-value-row">
          <div class="sd-flex" style="flex:1">
            <div class="field-name" :title="field.name">{{ field.name }}</div>
            <el-input v-model="field.value" size="mini" :disabled="field.fixed" ></el-input>
            <i class="clickable sd-hover" :class="field.fixed?'el-icon-lock':'el-icon-unlock'" style="margin-top: 5px;" @click="field.fixed=!field.fixed" />
          </div>
          <i class="el-icon-minus clickable" @click="removeFieldRow(field)" title="删除" style="padding:6px; color:red; flex:0 16px;"></i>
          </div>
      </div>
    </div>
    <div class="editor-panle__foot">
      <div class="content-row">
        <el-button type="danger"  @click="removeFeature">清除图形</el-button>
        <el-button type="primary"  @click="handleSaveFeature">保存</el-button>
        <el-button @click="close">关闭</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import { Draw,Modify,Select,Snap } from 'ol/interaction';
import {click,altKeyOnly } from 'ol/events/condition.js';
import GeoserverLayer from './MapServer/GeoserverLayer';
import { Point } from "ol/geom";

import { CoreMap } from '@/components/OlMap/Utils/CoreMap'; 
import {TEMPLATE_LAYER_INDEX}from '@/components/Constants/LayerIndex'
import GeoJsonUtil from '@/components/OlMap/Utils/GeoJsonUtil';
import TurfUtil from '@/components/OlMap/Utils/TurfUtil';
import { Loading } from 'element-ui';
const GEOSERVER_FIELD='geoserver'
const LAYER_FIELD = 'ol_layer'
const LAYER_NAME = 'templateGeometryEditorLayer' 
export default {
  name: 'SdGeometryEditor',
  props:{
  },
  data() {
    return {
      map_:null,
      mapCtrl_:null,
      projection_:null,
      tpDrawLayer_:null,
      drawTool_:null,
      modifyTool_:null,
      selectTool_:null,
      selectFeature_:null, //当前修改的要素,
      canModify_:false,
      hasModify_:false,
      lastModifyFeature_:null,
      isRectifyingGeometry_:false,
      attributeFields_:[],
      layerInfo_:null,
      selectField_:null,
      filterFields_:[],
      displayFields_:[],
      fieldCache_:{},
      loaddingIns_:false,
      dialogVisible_:false,
      isEditorModel_:true,
      addible_:false
    };
  },
  mounted() {
    if (!this.map_ && this.$parent.map_) {
      this.setMap(this.$parent.map_,this.$parent)
    }
    document.onkeyup = (evt)=>{
      if (evt.code==='Space' ) {
        if (this.drawTool_) {
          this.drawTool_.finishDrawing()
        }else{
          this.handleSaveFeature()
        }
      }
      if(evt.code==='Escape'){
        this.modifyTool_ && this.removeModifyTool()
        this.drawTool_ && this.removeDrawTool()
      }
    }
  },
  beforeDestroy() {
    
    this.close()
    
  },
  methods: {
    handleSaveFeature(){
      if(this.isRectifyingGeometry_){
        this.rectifyGeometryOfSelected(this.selectFeature_).then(()=>{
          this.saveFeature()
        })
      }else{
        this.saveFeature()
      }
    },
    
    setMap(map,mapCtrl){
      this.map_ = map
      this.mapCtrl_ = mapCtrl
      this.projection_ = this.map_.getView().getProjection().getCode()
      
    },
    open(layerInfo){
      this.dialogVisible_ = true
      this.initLayer()
      this.addSelectTool()
      this.addModifyTool(this.isEditorModel_)
      this.layerInfo_ = layerInfo||{}
      let driver = this.getGeoserver()
      //*************测试数据 注释 *************/
      // if(!driver){
      //   this.layerInfo_.alias='长沙建筑'
      //   driver= new GeoserverLayer({
      //     url:'http://192.168.2.40:8080/geoserver/gy/wms',
      //     layer:'gy:changsha',
      //     projection:this.projection_,
      //   })
      //   this.layerInfo_[GEOSERVER_FIELD] = driver
      // }
      //*************end 注释 *************/
      
      const fields= this.fieldCache_[driver.id]
      if(fields){
        this.initField(fields)
      }else{
        driver && this.addLoading() && driver.getFields().then(fields=>{
          this.removeLoading()
          this.fieldCache_[driver.id] =fields
          this.initField(fields)
        })
      }
      
    },
    close(){
      this.dialogVisible_ = false
      this.removeSelectTool()
      this.map_ && this.tpDrawLayer_ && this.map_.removeLayer(this.tpDrawLayer_)
      this.clear()

    },
    clear(){
      this.modifyTool_ && this.removeModifyTool()
      this.drawTool_ && this.removeDrawTool()
      this.tpDrawLayer_ && this.tpDrawLayer_.getSource().clear()
    },
    initLayer(){
      //初始化临时绘制图层
      this.tpDrawLayer_ = CoreMap.getVectorLayer({
        zIndex:TEMPLATE_LAYER_INDEX,
        style:()=>{return CoreMap.getEditorStyle()}
      })
      this.tpDrawLayer_.name = LAYER_NAME
      this.tpDrawLayer_.set('name',LAYER_NAME)
      this.map_ && this.map_.addLayer(this.tpDrawLayer_)
    },
    initField(fields){
      const arr = []
      fields.forEach(f=>{
        if(f.type.includes('gml:')){
          this.addible_ = f.localType.toLowerCase()!=='geometry'
        }else{
          arr.push(f.name)
        }
      })
      this.attributeFields_ = arr
      this.displayFields_ = []
      this.filterFields_ =this.attributeFields_
    },
    addDrawTool(){
      if(this.modifyTool_){
        this.removeModifyTool()
      }
      if (this.drawTool_) {
        this.removeDrawTool()
        return
      }
      const geomType = this.getGeometryType()
      if (!geomType) {
        this.$message({message: '当前图层数据类型不支持编辑',type: 'warning',})
        this.addible_ = false
        return
      }
      
      this.drawTool_ = new Draw({
        type:geomType,
      })
      this.drawTool_.on('drawend',(evt)=>{
        const feature = evt.feature
        this.addFeatureToEditorLayer(feature,true)
        if(this.isRectifyingGeometry_){
          this.rectifyGeometryOfSelected(feature).then(()=>{
            this.saveFeature()
          })
        }else{
          this.saveFeature()
        }
        // this.removeDrawTool() //取消连续绘制
      })
      this.map_ && this.map_.addInteraction(this.drawTool_)
      this.removeSelectTool()
    },
    removeDrawTool(){
      if (this.map_ && this.drawTool_) {
        this.map_.removeInteraction(this.drawTool_) 
        this.drawTool_ = null
        this.addSelectTool()
      }
    },
    addModifyTool(isAdd){
      if (this.drawTool_) {
        this.removeDrawTool()
      }
      this.hasModify_ = false
      this.removeModifyTool()
      if (!isAdd) return
      this.modifyTool_ = new Modify({
        source:this.tpDrawLayer_.getSource()
      })
      this.modifyTool_.on('modifyend',(evt)=>{
        this.hasModify_ = true
      })
      this.map_ && this.map_.addInteraction(this.modifyTool_)
    },
    removeModifyTool(){
      if (this.map_ && this.modifyTool_) {
        this.map_.removeInteraction(this.modifyTool_) 
        this.modifyTool_ = null
      }
    },
    addSelectTool(){
      if (!this.map_) {
        return
      }
      this.removeSelectTool()
      this.selectTool_ = this.map_.on('singleclick',(evt)=>{
        const clickCondition = true //evt.originalEvent.ctrlKey || altKeyOnly(evt)
        if(clickCondition){
          const coord = this.map_.getCoordinateFromPixel(evt.pixel)
          const resolution = this.getResolution()
          const driver = this.getGeoserver()
          driver && driver.pointQuery(new Point(coord),resolution).then(res=>{
            if (res.type) {
              const features = GeoJsonUtil.readFeatures(res)
              const feature = features && features.length>0 ? features[0] : null
              this.addFeatureToEditorLayer(feature)
            }else{
              this.$message({
                message: '查询图层服务失败',
                type: 'warning',
              })
            }
          })
        }
      })
    },
    addFeatureToEditorLayer(features,isNew=false){
      this.tpDrawLayer_.getSource().clear()
      this.selectFeature_ = null
      if (!features) {
        return 
      }
      const arr = Array.isArray(features)? features : [features]
      this.selectFeature_ = arr[0]
      this.selectFeature_ && this.tpDrawLayer_.getSource().addFeatures([this.selectFeature_])
      !isNew && this.selectFeature_ && this.displayFields_.forEach(f=>{
        if(!f.fixed){
          const value = this.selectFeature_.get(f.name)
          f.value = value
        }
      })
      
    },
    addFieldRow(){
      this.displayFields_.push({name:this.selectField_,value:this.getFieldValue(this.selectField_),fixed:false})
      this.selectField_ = null
      const fields = this.displayFields_.map(item=>item.name)
      this.filterFields_ = this.attributeFields_.filter(item=>!fields.includes(item))
    },
    removeFieldRow(field){
      this.displayFields_ = this.displayFields_.filter(item=>item!==field)
      const fields = this.displayFields_.map(item=>item.name)
      this.filterFields_ = this.attributeFields_.filter(item=>!fields.includes(item))
    },
    removeSelectTool(){
      if (this.map_ && this.selectTool_) {
        this.map_.un(this.selectTool_.type,this.selectTool_.listener)
        this.selectTool_=null
      }
    },
    saveFeature(){
      if (!this.selectFeature_) {
        return
      }
      const properties = {}
      this.displayFields_.forEach(item=>{
        item.value && (properties[item.name]=item.value)
      })
      const driver = this.getGeoserver()
      if (!driver) return
      const id = this.selectFeature_.getId()
      this.addLoading()
      if(id){
        driver.updateFeature(this.selectFeature_,properties).then(()=>{
          this.removeLoading()
          this.$message({message:'保存成功！',type:'success'})
          this.refreshLayerSource()
        }).catch(error=>{
          this.removeLoading()
          this.$message.error("修改失败，" + error)
        })
      }else{
        driver.addFeature(this.selectFeature_,properties).then(()=>{
          this.removeLoading()
          this.$message({message:'保存成功！',type:'success'})
          this.refreshLayerSource()
          this.addFeatureToEditorLayer()
        }).catch(error=>{
          this.removeLoading()
          this.addFeatureToEditorLayer()
          this.$message.error('保存失败，'+ error)
        })
      }
      this.$emit('save-feature',this.selectFeature_)
    },
    removeFeature(){
      if (!this.selectFeature_) {
        return
      }
      this.$confirm('是否删除当前记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        if(!this.selectFeature_.getId()) return
          const driver = this.getGeoserver()
          this.addLoading()
          driver && driver.deleteFeatures(this.selectFeature_).then(()=>{
            this.$emit('remove-feature',this.selectFeature_)
            this.$message({message:'删除成功！',type:'success'})
            this.addFeatureToEditorLayer()
            this.refreshLayerSource()
            this.removeLoading()
          }).catch(error=>{
            this.removeLoading()
            this.$message.error('删除失败，'+error)
            this.addFeatureToEditorLayer()
          })
      })
    },
    removeGeometry(){
      if (!this.selectFeature_) {
        return
      }
      this.$confirm('是否删除当前图形?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        if(this.selectFeature_.getId()){
          this.selectFeature_.setGeoemtry(null)
          const driver = this.getGeoserver()
          driver && driver.updateFeature(this.selectFeature_).then(()=>{
            this.$emit('clear-geometry',this.selectFeature_)
            this.$message({message:'清除图形成功！',type:'success'})
            this.addFeatureToEditorLayer()
            this.refreshLayerSource()
          }).catch(error=>{
            this.$message.error('清除图形失败，' + error)
          })
        }else{
          this.addFeatureToEditorLayer()
        }
      })
    },
    refreshLayerSource(){
      const layer = this.layerInfo_[LAYER_FIELD]
      layer && layer.getSource().refresh()
    },
    rectifyGeometryOfSelected(feature){
      return new Promise(resolve=>{
        const driver = this.getGeoserver()
        const geometry = feature.getGeometry()
        driver && geometry && driver.polygonQuery(geometry)
        .then(json=>{
          try {
            const features = CoreMap.readFeatures(json)
            let geom=feature.getGeometry()
            features && features.forEach(feature=>{
              if (feature.getId()!==this.selectFeature_.getId()) {
                const mask = TurfUtil.mask(geom, feature.getGeometry())
                geom = mask?mask:geom
              }
            })
            geom && feature.setGeometry(geom)
            resolve()
          } catch (error) {
            this.$message.error('修改失败！')
            console.error(error.message)
          } 
        })
      })
      
    },
    addLoading(){
      this.loaddingIns_ && this.loaddingIns_.close()
      const options = {
        target:this.$el
      }
      this.loaddingIns_ = Loading.service(options);
      return true
    },
    removeLoading(){
      this.loaddingIns_ && this.loaddingIns_.close()
      this.loaddingIns_ = null
    },
    getResolution(){
      return this.map_ ? this.map_.getView().getResolution() : 0
    },
    getGeometryType(){
      const driver =this.getGeoserver()
      const tp = driver?.geometryType.toLowerCase() || ''
      if (tp.includes('polygon')) {
        return 'Polygon'
      }else if(tp.includes('linestring')){
        return 'LineString'
      }else if(tp.includes('point')){
        return 'Point'
      }else{
        return ''
      }
    },
    getGeoserver(){
      return this.layerInfo_ ? this.layerInfo_[GEOSERVER_FIELD] : null
    },
    getFieldValue(field){
      return this.selectFeature_ ? this.selectFeature_.get(field) : ''
    },
  },
};
</script>
<style scoped>
.sd-geometry-editor{
  position: absolute;
  left: calc(100% - 340px);
  top:80px;
  background-color: white;
  padding: 10px;
  text-align: left;
  min-width:310px;
  border-radius:10px;
}
.content-row{
  margin: 10px 0;
}
.input-field-values{
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #e1e1e1;
}
.field-value-row{
  margin: 5px 0;
  height:28px;
  line-height:28px;
}
.field-name{
  width:80px;
  text-align: center;
  word-wrap: break-word; /*强制换行*/
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis;/*隐藏后添加省略号*/
  white-space: nowrap;/*强制不换行*/
}

</style>